import ActionType from './action-type'
import * as Actions from './actions'
import {ErrorOccurred} from '../session-data/action-creators'
import {AnyAction} from 'redux'
import {ThunkAction} from 'redux-thunk'

import {Api} from '../../../api/api'
import AppState from '../../types/app-state'
import {fetchCallHomeRequests} from '../call-home-request/action-creators'
import {fetchLocations} from '../locations/action-creators'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function logout(): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (dispatch: any): void => {
        dispatch(clearAuthToken())
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function errorOccured(error: string): any {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (dispatch: any): void => {
        dispatch(ErrorOccurred(error))
    }
}

export function authTokenRetrieved(authToken: string): Actions.AuthTokenRetrievedAction {
    return {
        type: ActionType.RECEIVE_AUTH_TOKEN,
        payload: authToken,
    }
}

export function clearAuthToken(): Actions.ClearAuthTokenAction {
    return {
        type: ActionType.CLEAR_AUTH_TOKEN,
    }
}

export function fetchInitialData(): ThunkAction<void, AppState, Api, AnyAction> {
    return (dispatch) => {
        dispatch(fetchCallHomeRequests())
        dispatch(fetchLocations())
    }
}
export function fetchExtendedData(): ThunkAction<void, AppState, Api, AnyAction> {
    return () => {
        // eslint-disable-next-line no-console
        console.log('to be filled in as API becomes available')
    }
}
